import type {
    SendWhatsAppDTO,
    SendWhatsAppTemplatePayload,
} from 'src/shared/communications';

export interface MessagePayloadForWhatsApp {
    to: string;
    from: string;
    body: string;
    by?: { name: string; id: string };
    area?: string;
    storeId?: string;
    channel?: string;
    MediaUrl0?: string;
    MediaContentType0?: string;
    isAssistantGenerated?: boolean;
}

export interface TemplatePayloadForWhatsApp {
    _id?: string;
    to: string | null;
    from: string | null;
    body: string;
    by?: { name: string; id: string };
    area?: string;
    storeId?: string;
    channel?: string;
    templateType?: string;
    messageWithoutFormat?: string;
    options?: Record<string, string>;
    templateTitle?: string;
    contentSid?: string;
    contentTemplateBuilder?: {
        contentSid: string;
        contentVariablesType?: string;
    };
    language?: string;
    title?: string;
    message?: string;
    api?: string;
    isAssistantGenerated?: boolean;
}

/** Maps sendType (API_TWILIO | API_WSP) from formatMessageToSend to provider */
function toProvider(sendType?: string): 'twilio' | 'wsp' | undefined {
    if (!sendType) return undefined;
    if (sendType === 'twilio') return 'twilio';
    if (sendType === 'wsp') return 'wsp';
    return undefined;
}

export function mapMessagePayloadToSendWhatsAppDTO(
    values: MessagePayloadForWhatsApp,
    sendType?: string
): SendWhatsAppDTO {
    return {
        to: values.to,
        from: values.from,
        message: values.body,
        sender: values.by,
        area: values.area,
        storeId: values.storeId,
        channel: values.channel,
        mediaUrl: values.MediaUrl0,
        mediaContentType: values.MediaContentType0,
        provider: toProvider(sendType),
        isAssistantGenerated: values.isAssistantGenerated,
    };
}

export function mapTemplatePayloadToSendWhatsAppDTO(
    values: TemplatePayloadForWhatsApp,
    leadId?: string
): SendWhatsAppDTO {
    const templatePayload: SendWhatsAppTemplatePayload = {};
    if (values._id) templatePayload._id = values._id;
    if (values.templateType) templatePayload.templateType = values.templateType;
    if (values.messageWithoutFormat)
        templatePayload.messageWithoutFormat = values.messageWithoutFormat;
    if (values.options) templatePayload.options = values.options;
    if (values.templateTitle)
        templatePayload.templateTitle = values.templateTitle;
    if (values.contentSid) templatePayload.contentSid = values.contentSid;
    if (values.contentTemplateBuilder)
        templatePayload.contentTemplateBuilder = values.contentTemplateBuilder;
    if (values.language) templatePayload.language = values.language;
    if (values.body) templatePayload.body = values.body;
    if (values.title) templatePayload.title = values.title;

    return {
        to: values.to ?? '',
        from: values.from ?? '',
        message: values.body ?? values.message ?? '',
        sender: values.by,
        area: values.area,
        storeId: values.storeId,
        channel: values.channel,
        leadId,
        provider: toProvider(values.api),
        isAssistantGenerated: values.isAssistantGenerated,
        templatePayload: Object.keys(templatePayload).length
            ? templatePayload
            : undefined,
    };
}
